document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('component video-card');

  if (run.length > 0) {
    const videoCards = document.querySelectorAll('.component.video-card');

    videoCards.forEach((videoCard) => {
      videoCard.addEventListener('click', (e) => {
        const id = videoCard.dataset.id;
        const code = videoCard.dataset.video;

        videoCard.querySelectorAll('.details').forEach((detail) => {
          detail.classList.add('hidden');
        });
        
        const video = document.querySelector('#' + id);
        videoCard.appendChild(video);
        videoCard.classList.remove('flex');
        videoCard.classList.remove('p-4');
        video.classList.remove('hidden');

        const player = Wistia.api(code);
        player.time(4);
        player.play();
      }, { once: true });
    });
  }
});
